// Static per-page SEO metadata (source: SMIK_Learn_Site_Pages_SEO_Metadata.docx).
// Keyed by route path.
const seoMetadata = {
  "/": {
    "page": "Home",
    "title": "Yuvasakthi Academy | Online Courses & Professional Skill Development",
    "description": "Yuvasakthi Academy offers online courses and professional skill development programs designed to help learners build practical skills and advance their careers.",
    "keywords": "Yuvasakthi Academy, online courses, professional skill development, online learning, skill development courses, career development courses, technical courses, online training, professional training, Yuvasakthi Academy courses",
    "ogTitle": "Yuvasakthi Academy | Online Courses & Professional Skill Development",
    "ogDescription": "Explore Yuvasakthi Academy online courses and professional skill development programs designed to help learners build practical skills and advance their careers.",
    "ogUrl": "https://yslearn.in/",
    "ogSiteName": "Yuvasakthi Academy",
    "ogLocale": "en_IN",
    "ogImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "ogImageWidth": "1200",
    "ogImageHeight": "630",
    "ogImageAlt": "Yuvasakthi Academy - Online Courses and Professional Skill Development",
    "ogType": "website",
    "twitterTitle": "Yuvasakthi Academy | Online Courses & Professional Skill Development",
    "twitterDescription": "Explore Yuvasakthi Academy courses and professional skill development programs to build practical skills and support career growth.",
    "twitterCard": "summary_large_image",
    "twitterCreator": "@yslearn",
    "twitterImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "twitterImageWidth": "1200",
    "twitterImageHeight": "630",
    "twitterImageAlt": "Yuvasakthi Academy - Online Courses and Professional Skill Development",
    "twitterSite": "@yslearn",
    "twitterUrl": "https://yslearn.in/",
    "searchTitle": "Yuvasakthi Academy - Online Courses & Professional Skill Development",
    "focusArea": "Online Learning, Technical Courses, Professional Training and Skill Development",
    "primaryTaxonomy": "Education > Online Learning > Professional Skill Development",
    "primaryTopic": "Yuvasakthi Academy Online Courses and Professional Skill Development",
    "pageType": "WebPage"
  },
  "/about": {
    "page": "About",
    "title": "About Yuvasakthi Academy | Online Learning & Professional Training",
    "description": "Learn about Yuvasakthi Academy, an online learning platform offering professional training, practical learning, industry-relevant courses, mentorship, and career development support.",
    "keywords": "about Yuvasakthi Academy, Yuvasakthi Academy, online learning platform, professional training, online training, skill development, technical training, practical learning, industry training, career development, professional courses, Yuvasakthi Academy training",
    "ogTitle": "About Yuvasakthi Academy | Online Learning & Professional Training",
    "ogDescription": "Learn about Yuvasakthi Academy and its approach to professional training, practical learning, industry-relevant courses, mentorship, and career development.",
    "ogUrl": "https://yslearn.in/about",
    "ogSiteName": "Yuvasakthi Academy",
    "ogLocale": "en_IN",
    "ogImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "ogImageWidth": "1200",
    "ogImageHeight": "630",
    "ogImageAlt": "Yuvasakthi Academy - About Us",
    "ogType": "website",
    "twitterTitle": "About Yuvasakthi Academy | Online Learning & Professional Training",
    "twitterDescription": "Learn about Yuvasakthi Academy and its approach to professional training, practical learning, industry-relevant courses, mentorship, and career development.",
    "twitterCard": "summary_large_image",
    "twitterCreator": "@yslearn",
    "twitterImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "twitterImageWidth": "1200",
    "twitterImageHeight": "630",
    "twitterImageAlt": "Yuvasakthi Academy - About Us",
    "twitterSite": "@yslearn",
    "twitterUrl": "https://yslearn.in/about",
    "searchTitle": "About Yuvasakthi Academy - Online Learning & Professional Training",
    "focusArea": "Yuvasakthi Academy, Online Learning, Professional Training, Skill Development and Career Development",
    "primaryTaxonomy": "Education > Online Learning > Professional Training",
    "primaryTopic": "About Yuvasakthi Academy",
    "pageType": "WebPage"
  },
  "/careers": {
    "page": "Careers",
    "title": "Careers at Yuvasakthi Academy | Job Opportunities & Career Growth",
    "description": "Explore career opportunities at Yuvasakthi Academy and discover roles focused on professional growth, learning, technology, training, and digital skills development.",
    "keywords": "Yuvasakthi Academy careers, Yuvasakthi Academy jobs, careers at Yuvasakthi Academy, Yuvasakthi Academy job opportunities, online learning careers, training careers, technology jobs, career opportunities, professional growth, education technology careers, digital skills careers, Yuvasakthi Academy",
    "ogTitle": "Careers at Yuvasakthi Academy | Job Opportunities & Career Growth",
    "ogDescription": "Explore career opportunities at Yuvasakthi Academy and discover roles focused on professional growth, learning, technology, training, and digital skills development.",
    "ogUrl": "https://yslearn.in/careers",
    "ogSiteName": "Yuvasakthi Academy",
    "ogLocale": "en_IN",
    "ogImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "ogImageWidth": "1200",
    "ogImageHeight": "630",
    "ogImageAlt": "Yuvasakthi Academy - Careers and Job Opportunities",
    "ogType": "website",
    "twitterTitle": "Careers at Yuvasakthi Academy | Job Opportunities & Career Growth",
    "twitterDescription": "Explore career opportunities at Yuvasakthi Academy and discover roles focused on professional growth, learning, technology, training, and digital skills development.",
    "twitterCard": "summary_large_image",
    "twitterCreator": "@yslearn",
    "twitterImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "twitterImageWidth": "1200",
    "twitterImageHeight": "630",
    "twitterImageAlt": "Yuvasakthi Academy - Careers and Job Opportunities",
    "twitterSite": "@yslearn",
    "twitterUrl": "https://yslearn.in/careers",
    "searchTitle": "Yuvasakthi Academy Careers - Job Opportunities & Career Growth",
    "focusArea": "Yuvasakthi Academy Careers, Job Opportunities, Professional Growth, Technology and Digital Skills",
    "primaryTaxonomy": "Careers > Job Opportunities > Education and Technology",
    "primaryTopic": "Yuvasakthi Academy Careers and Job Opportunities",
    "pageType": "WebPage"
  },
  "/press": {
    "page": "Press",
    "title": "Yuvasakthi Academy Press | News, Media & Company Updates",
    "description": "Explore Yuvasakthi Academy press releases, media coverage, announcements, company updates, and news about online learning and professional skill development.",
    "keywords": "Yuvasakthi Academy press, Yuvasakthi Academy news, Yuvasakthi Academy media, Yuvasakthi Academy press releases, Yuvasakthi Academy announcements, Yuvasakthi Academy company news, Yuvasakthi Academy updates, online learning news, professional training news, education technology news, Yuvasakthi Academy media coverage",
    "ogTitle": "Yuvasakthi Academy Press | News, Media & Company Updates",
    "ogDescription": "Explore Yuvasakthi Academy press releases, media coverage, announcements, company updates, and news about online learning and professional skill development.",
    "ogUrl": "https://yslearn.in/press",
    "ogSiteName": "Yuvasakthi Academy",
    "ogLocale": "en_IN",
    "ogImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "ogImageWidth": "1200",
    "ogImageHeight": "630",
    "ogImageAlt": "Yuvasakthi Academy - Press, News and Media",
    "ogType": "website",
    "twitterTitle": "Yuvasakthi Academy Press | News, Media & Company Updates",
    "twitterDescription": "Explore Yuvasakthi Academy press releases, media coverage, announcements, company updates, and news about online learning and professional skill development.",
    "twitterCard": "summary_large_image",
    "twitterCreator": "@yslearn",
    "twitterImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "twitterImageWidth": "1200",
    "twitterImageHeight": "630",
    "twitterImageAlt": "Yuvasakthi Academy - Press, News and Media",
    "twitterSite": "@yslearn",
    "twitterUrl": "https://yslearn.in/press",
    "searchTitle": "Yuvasakthi Academy Press - News, Media & Company Updates",
    "focusArea": "Yuvasakthi Academy Press, Media Coverage, Company News, Announcements and Online Learning",
    "primaryTaxonomy": "Company > Press and Media > News and Updates",
    "primaryTopic": "Yuvasakthi Academy Press and Media",
    "pageType": "WebPage"
  },
  "/review": {
    "page": "Reviews",
    "title": "Yuvasakthi Academy Reviews | Learner Feedback & Course Reviews",
    "description": "Read Yuvasakthi Academy reviews, learner feedback, testimonials, and course experiences to learn more about online training and professional skill development programs.",
    "keywords": "Yuvasakthi Academy reviews, Yuvasakthi Academy review, Yuvasakthi Academy feedback, Yuvasakthi Academy testimonials, Yuvasakthi Academy course reviews, Yuvasakthi Academy learner feedback, online course reviews, training course reviews, professional training reviews, online learning feedback, Yuvasakthi Academy courses",
    "ogTitle": "Yuvasakthi Academy Reviews | Learner Feedback & Course Reviews",
    "ogDescription": "Read Yuvasakthi Academy reviews, learner feedback, testimonials, and course experiences to learn more about online training and professional skill development programs.",
    "ogUrl": "https://yslearn.in/review",
    "ogSiteName": "Yuvasakthi Academy",
    "ogLocale": "en_IN",
    "ogImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "ogImageWidth": "1200",
    "ogImageHeight": "630",
    "ogImageAlt": "Yuvasakthi Academy - Learner Reviews and Feedback",
    "ogType": "website",
    "twitterTitle": "Yuvasakthi Academy Reviews | Learner Feedback & Course Reviews",
    "twitterDescription": "Read Yuvasakthi Academy reviews, learner feedback, testimonials, and course experiences to learn more about online training and professional skill development programs.",
    "twitterCard": "summary_large_image",
    "twitterCreator": "@yslearn",
    "twitterImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "twitterImageWidth": "1200",
    "twitterImageHeight": "630",
    "twitterImageAlt": "Yuvasakthi Academy - Learner Reviews and Feedback",
    "twitterSite": "@yslearn",
    "twitterUrl": "https://yslearn.in/review",
    "searchTitle": "Yuvasakthi Academy Reviews - Learner Feedback & Course Reviews",
    "focusArea": "Yuvasakthi Academy Reviews, Learner Feedback, Course Reviews, Testimonials and Online Training",
    "primaryTaxonomy": "Education > Online Learning > Course Reviews and Learner Feedback",
    "primaryTopic": "Yuvasakthi Academy Reviews and Learner Feedback",
    "pageType": "WebPage"
  },
  "/contact": {
    "page": "Contact",
    "title": "Contact Yuvasakthi Academy | Course Enquiries & Training Support",
    "description": "Contact Yuvasakthi Academy for course enquiries, training information, learning support, professional courses, and assistance with online and classroom training.",
    "keywords": "contact Yuvasakthi Academy, Yuvasakthi Academy contact, Yuvasakthi Academy support, Yuvasakthi Academy course enquiry, Yuvasakthi Academy training enquiry, online training support, course information, professional training support, Yuvasakthi Academy courses, training assistance, Yuvasakthi Academy",
    "ogTitle": "Contact Yuvasakthi Academy | Course Enquiries & Training Support",
    "ogDescription": "Contact Yuvasakthi Academy for course enquiries, training information, learning support, professional courses, and assistance with online and classroom training.",
    "ogUrl": "https://yslearn.in/contact",
    "ogSiteName": "Yuvasakthi Academy",
    "ogLocale": "en_IN",
    "ogImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "ogImageWidth": "1200",
    "ogImageHeight": "630",
    "ogImageAlt": "Yuvasakthi Academy - Contact and Training Support",
    "ogType": "website",
    "twitterTitle": "Contact Yuvasakthi Academy | Course Enquiries & Training Support",
    "twitterDescription": "Contact Yuvasakthi Academy for course enquiries, training information, learning support, professional courses, and assistance with online and classroom training.",
    "twitterCard": "summary_large_image",
    "twitterCreator": "@yslearn",
    "twitterImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "twitterImageWidth": "1200",
    "twitterImageHeight": "630",
    "twitterImageAlt": "Yuvasakthi Academy - Contact and Training Support",
    "twitterSite": "@yslearn",
    "twitterUrl": "https://yslearn.in/contact",
    "searchTitle": "Contact Yuvasakthi Academy - Course Enquiries & Training Support",
    "focusArea": "Yuvasakthi Academy Contact, Course Enquiries, Training Support, Learning Assistance and Professional Courses",
    "primaryTaxonomy": "Education > Online Learning > Course Enquiries and Support",
    "primaryTopic": "Contact Yuvasakthi Academy",
    "pageType": "WebPage"
  },
  "/grievance-redressal": {
    "page": "Grievance Redressal",
    "title": "Grievance Redressal | Complaints & Learner Support - Yuvasakthi Academy",
    "description": "Learn about the Yuvasakthi Academy grievance redressal process for raising complaints, concerns, and learner issues related to courses, training, and learning support.",
    "keywords": "Yuvasakthi Academy grievance redressal, grievance redressal, Yuvasakthi Academy complaints, Yuvasakthi Academy complaint process, learner grievance, student grievance, training complaints, course complaints, learner support, education grievance, Yuvasakthi Academy support",
    "ogTitle": "Grievance Redressal | Complaints & Learner Support - Yuvasakthi Academy",
    "ogDescription": "Learn about the Yuvasakthi Academy grievance redressal process for raising complaints, concerns, and learner issues related to courses, training, and learning support.",
    "ogUrl": "https://yslearn.in/grievance-redressal",
    "ogSiteName": "Yuvasakthi Academy",
    "ogLocale": "en_IN",
    "ogImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "ogImageWidth": "1200",
    "ogImageHeight": "630",
    "ogImageAlt": "Yuvasakthi Academy - Grievance Redressal and Learner Support",
    "ogType": "website",
    "twitterTitle": "Grievance Redressal | Complaints & Learner Support - Yuvasakthi Academy",
    "twitterDescription": "Learn about the Yuvasakthi Academy grievance redressal process for raising complaints, concerns, and learner issues related to courses, training, and learning support.",
    "twitterCard": "summary_large_image",
    "twitterCreator": "@yslearn",
    "twitterImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "twitterImageWidth": "1200",
    "twitterImageHeight": "630",
    "twitterImageAlt": "Yuvasakthi Academy - Grievance Redressal and Learner Support",
    "twitterSite": "@yslearn",
    "twitterUrl": "https://yslearn.in/grievance-redressal",
    "searchTitle": "Yuvasakthi Academy Grievance Redressal - Complaints & Learner Support",
    "focusArea": "Grievance Redressal, Learner Complaints, Student Support, Course Concerns and Training Support",
    "primaryTaxonomy": "Education > Student Support > Grievance Redressal",
    "primaryTopic": "Yuvasakthi Academy Grievance Redressal",
    "pageType": "WebPage"
  },
  "/becomeaninstructor": {
    "page": "Become an Instructor",
    "title": "Become an Instructor | Teach Online with Yuvasakthi Academy",
    "description": "Become an instructor with Yuvasakthi Academy and share your knowledge through online teaching, professional courses, skill development, and practical learning programs.",
    "keywords": "become an instructor, Yuvasakthi Academy instructor, teach online, online instructor, online teaching, instructor opportunities, teaching opportunities, create online courses, professional course instructor, online course teaching, Yuvasakthi Academy teaching, Yuvasakthi Academy",
    "ogTitle": "Become an Instructor | Teach Online with Yuvasakthi Academy",
    "ogDescription": "Become an instructor with Yuvasakthi Academy and share your knowledge through online teaching, professional courses, skill development, and practical learning programs.",
    "ogUrl": "https://yslearn.in/becomeaninstructor",
    "ogSiteName": "Yuvasakthi Academy",
    "ogLocale": "en_IN",
    "ogImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "ogImageWidth": "1200",
    "ogImageHeight": "630",
    "ogImageAlt": "Yuvasakthi Academy - Become an Instructor",
    "ogType": "website",
    "twitterTitle": "Become an Instructor | Teach Online with Yuvasakthi Academy",
    "twitterDescription": "Become an instructor with Yuvasakthi Academy and share your knowledge through online teaching, professional courses, skill development, and practical learning programs.",
    "twitterCard": "summary_large_image",
    "twitterCreator": "@yslearn",
    "twitterImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "twitterImageWidth": "1200",
    "twitterImageHeight": "630",
    "twitterImageAlt": "Yuvasakthi Academy - Become an Instructor",
    "twitterSite": "@yslearn",
    "twitterUrl": "https://yslearn.in/becomeaninstructor",
    "searchTitle": "Become an Instructor - Teach Online with Yuvasakthi Academy",
    "focusArea": "Online Teaching, Instructor Opportunities, Course Creation, Professional Training and Skill Development",
    "primaryTaxonomy": "Education > Online Learning > Instructor Opportunities",
    "primaryTopic": "Become an Instructor at Yuvasakthi Academy",
    "pageType": "WebPage"
  },
  "/smikrecruit": {
    "page": "SMIK Recruit",
    "title": "SMIK Recruit | Recruitment & Job Opportunities - Yuvasakthi Academy",
    "description": "Explore SMIK Recruit for recruitment, hiring opportunities, job connections, and career-related services from Yuvasakthi Academy.",
    "keywords": "SMIK Recruit, Yuvasakthi Academy recruitment, recruitment services, job opportunities, hiring services, recruitment platform, career opportunities, job recruitment, talent recruitment, employment opportunities, SMIK Recruit jobs, Yuvasakthi Academy",
    "ogTitle": "SMIK Recruit | Recruitment & Job Opportunities - Yuvasakthi Academy",
    "ogDescription": "Explore SMIK Recruit for recruitment, hiring opportunities, job connections, and career-related services from Yuvasakthi Academy.",
    "ogUrl": "https://yslearn.in/smikrecruit",
    "ogSiteName": "Yuvasakthi Academy",
    "ogLocale": "en_IN",
    "ogImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "ogImageWidth": "1200",
    "ogImageHeight": "630",
    "ogImageAlt": "SMIK Recruit - Recruitment and Job Opportunities",
    "ogType": "website",
    "twitterTitle": "SMIK Recruit | Recruitment & Job Opportunities - Yuvasakthi Academy",
    "twitterDescription": "Explore SMIK Recruit for recruitment, hiring opportunities, job connections, and career-related services from Yuvasakthi Academy.",
    "twitterCard": "summary_large_image",
    "twitterCreator": "@yslearn",
    "twitterImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "twitterImageWidth": "1200",
    "twitterImageHeight": "630",
    "twitterImageAlt": "SMIK Recruit - Recruitment and Job Opportunities",
    "twitterSite": "@yslearn",
    "twitterUrl": "https://yslearn.in/smikrecruit",
    "searchTitle": "SMIK Recruit - Recruitment & Job Opportunities | Yuvasakthi Academy",
    "focusArea": "Recruitment, Hiring, Job Opportunities, Career Opportunities and Talent Recruitment",
    "primaryTaxonomy": "Careers > Recruitment > Job Opportunities",
    "primaryTopic": "SMIK Recruit",
    "pageType": "WebPage"
  },
  "/skillup": {
    "page": "SkillUp",
    "title": "SkillUp | Online Skill Development & Learning - Yuvasakthi Academy",
    "description": "Explore SkillUp by Yuvasakthi Academy for online skill development, professional learning, practical training, and opportunities to build career-focused skills.",
    "keywords": "Yuvasakthi Academy SkillUp, SkillUp, skill development, online skill development, professional learning, online training, skill development courses, career skills, professional skills, practical learning, Yuvasakthi Academy",
    "ogTitle": "SkillUp | Online Skill Development & Learning - Yuvasakthi Academy",
    "ogDescription": "Explore SkillUp by Yuvasakthi Academy for online skill development, professional learning, practical training, and opportunities to build career-focused skills.",
    "ogUrl": "https://yslearn.in/skillup",
    "ogSiteName": "Yuvasakthi Academy",
    "ogLocale": "en_IN",
    "ogImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "ogImageWidth": "1200",
    "ogImageHeight": "630",
    "ogImageAlt": "Yuvasakthi Academy - SkillUp Online Skill Development",
    "ogType": "website",
    "twitterTitle": "SkillUp | Online Skill Development & Learning - Yuvasakthi Academy",
    "twitterDescription": "Explore SkillUp by Yuvasakthi Academy for online skill development, professional learning, practical training, and opportunities to build career-focused skills.",
    "twitterCard": "summary_large_image",
    "twitterCreator": "@yslearn",
    "twitterImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "twitterImageWidth": "1200",
    "twitterImageHeight": "630",
    "twitterImageAlt": "Yuvasakthi Academy - SkillUp Online Skill Development",
    "twitterSite": "@yslearn",
    "twitterUrl": "https://yslearn.in/skillup",
    "searchTitle": "SkillUp - Online Skill Development & Learning | Yuvasakthi Academy",
    "focusArea": "Skill Development, Online Learning, Professional Training, Practical Learning and Career Skills",
    "primaryTaxonomy": "Education > Online Learning > Skill Development",
    "primaryTopic": "Yuvasakthi Academy SkillUp",
    "pageType": "WebPage"
  },
  "/resourse": {
    "page": "Resources",
    "title": "Resources | Learning Materials & Career Resources - Yuvasakthi Academy",
    "description": "Explore Yuvasakthi Academy resources for learning materials, professional development, skill building, and career-focused information to support your learning journey.",
    "keywords": "Yuvasakthi Academy resources, learning resources, online learning resources, educational resources, learning materials, professional development resources, skill development resources, career resources, technical learning resources, Yuvasakthi Academy",
    "ogTitle": "Resources | Learning Materials & Career Resources - Yuvasakthi Academy",
    "ogDescription": "Explore Yuvasakthi Academy resources for learning materials, professional development, skill building, and career-focused information to support your learning journey.",
    "ogUrl": "https://yslearn.in/resourse",
    "ogSiteName": "Yuvasakthi Academy",
    "ogLocale": "en_IN",
    "ogImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "ogImageWidth": "1200",
    "ogImageHeight": "630",
    "ogImageAlt": "Yuvasakthi Academy - Learning Resources",
    "ogType": "website",
    "twitterTitle": "Resources | Learning Materials & Career Resources - Yuvasakthi Academy",
    "twitterDescription": "Explore Yuvasakthi Academy resources for learning materials, professional development, skill building, and career-focused information to support your learning journey.",
    "twitterCard": "summary_large_image",
    "twitterCreator": "@yslearn",
    "twitterImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "twitterImageWidth": "1200",
    "twitterImageHeight": "630",
    "twitterImageAlt": "Yuvasakthi Academy - Learning Resources",
    "twitterSite": "@yslearn",
    "twitterUrl": "https://yslearn.in/resourse",
    "searchTitle": "Yuvasakthi Academy Resources - Learning Materials & Career Resources",
    "focusArea": "Learning Resources, Educational Materials, Skill Development, Professional Development and Career Resources",
    "primaryTaxonomy": "Education > Online Learning > Educational Resources",
    "primaryTopic": "Yuvasakthi Academy Resources",
    "pageType": "WebPage"
  },
  "/forbusiness": {
    "page": "For Business",
    "title": "For Business | Corporate Training & Skill Development - Yuvasakthi Academy",
    "description": "Yuvasakthi Academy provides business-focused training and professional skill development programs designed to help organizations build digital skills and support workforce development.",
    "keywords": "Yuvasakthi Academy for business, corporate training, business training, corporate skill development, employee training, professional training, digital skills training, workforce development, corporate learning, business skills training, enterprise training, Yuvasakthi Academy",
    "ogTitle": "For Business | Corporate Training & Skill Development - Yuvasakthi Academy",
    "ogDescription": "Yuvasakthi Academy provides business-focused training and professional skill development programs designed to help organizations build digital skills and support workforce development.",
    "ogUrl": "https://yslearn.in/forbusiness",
    "ogSiteName": "Yuvasakthi Academy",
    "ogLocale": "en_IN",
    "ogImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "ogImageWidth": "1200",
    "ogImageHeight": "630",
    "ogImageAlt": "Yuvasakthi Academy - Corporate Training and Business Skill Development",
    "ogType": "website",
    "twitterTitle": "For Business | Corporate Training & Skill Development - Yuvasakthi Academy",
    "twitterDescription": "Yuvasakthi Academy provides business-focused training and professional skill development programs designed to help organizations build digital skills and support workforce development.",
    "twitterCard": "summary_large_image",
    "twitterCreator": "@yslearn",
    "twitterImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "twitterImageWidth": "1200",
    "twitterImageHeight": "630",
    "twitterImageAlt": "Yuvasakthi Academy - Corporate Training and Business Skill Development",
    "twitterSite": "@yslearn",
    "twitterUrl": "https://yslearn.in/forbusiness",
    "searchTitle": "Yuvasakthi Academy for Business - Corporate Training & Skill Development",
    "focusArea": "Corporate Training, Digital Skills, Workforce Development, Professional Training and Business Learning",
    "primaryTaxonomy": "Business > Corporate Training > Professional Skill Development",
    "primaryTopic": "Yuvasakthi Academy for Business and Corporate Training",
    "pageType": "WebPage"
  },
  "/learning-hub-plus": {
    "page": "Learning Hub Plus",
    "title": "Learning Hub Plus | Online Learning & Skill Development - Yuvasakthi Academy",
    "description": "Explore Learning Hub Plus by Yuvasakthi Academy for online learning, professional skill development, practical training, and career-focused learning opportunities.",
    "keywords": "Learning Hub Plus, Yuvasakthi Academy Learning Hub, online learning, skill development, professional learning, online training, professional training, career development, practical learning, learning programs, Yuvasakthi Academy",
    "ogTitle": "Learning Hub Plus | Online Learning & Skill Development - Yuvasakthi Academy",
    "ogDescription": "Explore Learning Hub Plus by Yuvasakthi Academy for online learning, professional skill development, practical training, and career-focused learning opportunities.",
    "ogUrl": "https://yslearn.in/learning-hub-plus",
    "ogSiteName": "Yuvasakthi Academy",
    "ogLocale": "en_IN",
    "ogImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "ogImageWidth": "1200",
    "ogImageHeight": "630",
    "ogImageAlt": "Yuvasakthi Academy - Learning Hub Plus",
    "ogType": "website",
    "twitterTitle": "Learning Hub Plus | Online Learning & Skill Development - Yuvasakthi Academy",
    "twitterDescription": "Explore Learning Hub Plus by Yuvasakthi Academy for online learning, professional skill development, practical training, and career-focused learning opportunities.",
    "twitterCard": "summary_large_image",
    "twitterCreator": "@yslearn",
    "twitterImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "twitterImageWidth": "1200",
    "twitterImageHeight": "630",
    "twitterImageAlt": "Yuvasakthi Academy - Learning Hub Plus",
    "twitterSite": "@yslearn",
    "twitterUrl": "https://yslearn.in/learning-hub-plus",
    "searchTitle": "Learning Hub Plus - Online Learning & Skill Development | Yuvasakthi Academy",
    "focusArea": "Online Learning, Professional Skill Development, Practical Training and Career Development",
    "primaryTaxonomy": "Education > Online Learning > Skill Development",
    "primaryTopic": "Yuvasakthi Academy Learning Hub Plus",
    "pageType": "WebPage"
  },
  "/guaranteed": {
    "page": "Guaranteed",
    "title": "Guaranteed | Career-Focused Training & Skill Development - Yuvasakthi Academy",
    "description": "Explore Yuvasakthi Academy's career-focused training and skill development programs designed to build practical skills, professional knowledge, and career readiness.",
    "keywords": "Yuvasakthi Academy guaranteed, Yuvasakthi Academy, career-focused training, skill development, professional training, career development, career readiness, online training, practical learning, professional courses, job-oriented training, Yuvasakthi Academy courses",
    "ogTitle": "Guaranteed | Career-Focused Training & Skill Development - Yuvasakthi Academy",
    "ogDescription": "Explore Yuvasakthi Academy's career-focused training and skill development programs designed to build practical skills, professional knowledge, and career readiness.",
    "ogUrl": "https://yslearn.in/guaranteed",
    "ogSiteName": "Yuvasakthi Academy",
    "ogLocale": "en_IN",
    "ogImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "ogImageWidth": "1200",
    "ogImageHeight": "630",
    "ogImageAlt": "Yuvasakthi Academy - Career-Focused Training and Skill Development",
    "ogType": "website",
    "twitterTitle": "Guaranteed | Career-Focused Training & Skill Development - Yuvasakthi Academy",
    "twitterDescription": "Explore Yuvasakthi Academy's career-focused training and skill development programs designed to build practical skills, professional knowledge, and career readiness.",
    "twitterCard": "summary_large_image",
    "twitterCreator": "@yslearn",
    "twitterImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "twitterImageWidth": "1200",
    "twitterImageHeight": "630",
    "twitterImageAlt": "Yuvasakthi Academy - Career-Focused Training and Skill Development",
    "twitterSite": "@yslearn",
    "twitterUrl": "https://yslearn.in/guaranteed",
    "searchTitle": "Yuvasakthi Academy Guaranteed - Career-Focused Training & Skill Development",
    "focusArea": "Career-Focused Training, Skill Development, Professional Learning and Career Readiness",
    "primaryTaxonomy": "Education > Career Development > Professional Skill Development",
    "primaryTopic": "Yuvasakthi Academy Guaranteed",
    "pageType": "WebPage"
  },
  "/partners": {
    "page": "Partners",
    "title": "Yuvasakthi Academy Partners | Training & Business Partnership Opportunities",
    "description": "Partner with Yuvasakthi Academy to provide digital skills training through distributor, channel partner, reseller, referral, and university partnership opportunities.",
    "keywords": "Yuvasakthi Academy partners, Yuvasakthi Academy partnership, training partnership, digital skills training partnership, business partnership, training partner, channel partner, training reseller, referral partner, university partnership, corporate training partnership, Yuvasakthi Academy",
    "ogTitle": "Yuvasakthi Academy Partners | Training & Business Partnership Opportunities",
    "ogDescription": "Partner with Yuvasakthi Academy to provide digital skills training through distributor, channel partner, reseller, referral, and university partnership opportunities.",
    "ogUrl": "https://yslearn.in/partners",
    "ogSiteName": "Yuvasakthi Academy",
    "ogLocale": "en_IN",
    "ogImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "ogImageWidth": "1200",
    "ogImageHeight": "630",
    "ogImageAlt": "Yuvasakthi Academy - Training and Business Partnership Opportunities",
    "ogType": "website",
    "twitterTitle": "Yuvasakthi Academy Partners | Training & Business Partnership Opportunities",
    "twitterDescription": "Partner with Yuvasakthi Academy to provide digital skills training through distributor, channel partner, reseller, referral, and university partnership opportunities.",
    "twitterCard": "summary_large_image",
    "twitterCreator": "@yslearn",
    "twitterImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "twitterImageWidth": "1200",
    "twitterImageHeight": "630",
    "twitterImageAlt": "Yuvasakthi Academy - Training and Business Partnership Opportunities",
    "twitterSite": "@yslearn",
    "twitterUrl": "https://yslearn.in/partners",
    "searchTitle": "Yuvasakthi Academy Partners - Training & Business Partnership Opportunities",
    "focusArea": "Training Partnerships, Digital Skills Training, Business Partnerships, Resellers, Universities and Channel Partners",
    "primaryTaxonomy": "Business > Partnerships > Digital Skills Training",
    "primaryTopic": "Yuvasakthi Academy Partnership Opportunities",
    "pageType": "WebPage"
  },
  "/demo": {
    "page": "Demo",
    "title": "Yuvasakthi Academy Demo | Explore Online Training & Learning Programs",
    "description": "Explore the Yuvasakthi Academy demo to discover online training programs, practical learning experiences, expert-led courses, and career-focused digital skills training.",
    "keywords": "Yuvasakthi Academy demo, online training demo, digital skills training, online learning platform, Yuvasakthi Academy courses, career training, professional training, practical learning",
    "ogTitle": "Yuvasakthi Academy Demo | Explore Online Training & Learning Programs",
    "ogDescription": "Explore the Yuvasakthi Academy demo and discover practical online training, expert-led courses, and career-focused digital skills learning.",
    "ogUrl": "https://yslearn.in/demo",
    "ogSiteName": "Yuvasakthi Academy",
    "ogLocale": "en_IN",
    "ogImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "ogImageWidth": "1200",
    "ogImageHeight": "630",
    "ogImageAlt": "Yuvasakthi Academy Online Training and Learning Platform",
    "ogType": "website",
    "twitterTitle": "Yuvasakthi Academy Demo | Explore Online Training & Learning Programs",
    "twitterDescription": "Explore the Yuvasakthi Academy demo and discover practical online training, expert-led courses, and career-focused digital skills learning.",
    "twitterCard": "summary_large_image",
    "twitterCreator": "@yslearn",
    "twitterImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "twitterImageWidth": "1200",
    "twitterImageHeight": "630",
    "twitterImageAlt": "Yuvasakthi Academy Online Training and Learning Platform",
    "twitterSite": "@yslearn",
    "twitterUrl": "https://yslearn.in/demo",
    "searchTitle": "Yuvasakthi Academy Demo - Online Training & Learning Platform",
    "focusArea": "Online Training, Digital Skills Learning, Career Development and Practical Education",
    "primaryTaxonomy": "Education > Online Learning > Professional Training",
    "primaryTopic": "Yuvasakthi Academy Online Training Demo",
    "pageType": "WebPage"
  },
  "/languisity": {
    "page": "Languisity",
    "title": "Languisity | Language Learning & Training Programs | Yuvasakthi Academy",
    "description": "Explore language learning and training programs with Yuvasakthi Academy designed to build practical communication skills and support personal and professional development.",
    "keywords": "Yuvasakthi Academy language learning, language training, language learning programs, language courses, online language learning, communication skills training, professional language training, Yuvasakthi Academy",
    "ogTitle": "Languisity | Language Learning & Training Programs | Yuvasakthi Academy",
    "ogDescription": "Explore language learning and training programs with Yuvasakthi Academy to develop practical communication and language skills.",
    "ogUrl": "https://yslearn.in/languisity",
    "ogSiteName": "Yuvasakthi Academy",
    "ogLocale": "en_IN",
    "ogImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "ogImageWidth": "1200",
    "ogImageHeight": "630",
    "ogImageAlt": "Yuvasakthi Academy Language Learning and Training Programs",
    "ogType": "website",
    "twitterTitle": "Languisity | Language Learning & Training Programs | Yuvasakthi Academy",
    "twitterDescription": "Explore language learning and training programs with Yuvasakthi Academy to develop practical communication and language skills.",
    "twitterCard": "summary_large_image",
    "twitterCreator": "@yslearn",
    "twitterImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "twitterImageWidth": "1200",
    "twitterImageHeight": "630",
    "twitterImageAlt": "Yuvasakthi Academy Language Learning and Training Programs",
    "twitterSite": "@yslearn",
    "twitterUrl": "https://yslearn.in/languisity",
    "searchTitle": "Languisity - Language Learning & Training Programs",
    "focusArea": "Language Learning, Communication Skills and Professional Language Training",
    "primaryTaxonomy": "Education > Language Learning > Language Training",
    "primaryTopic": "Language Learning and Training Programs",
    "pageType": "WebPage"
  },
  "/terms-and-conditions": {
    "page": "Terms and Conditions",
    "title": "Terms and Conditions | Yuvasakthi Academy",
    "description": "Read the Yuvasakthi Academy terms and conditions covering the use of our website, online learning services, courses, accounts, payments, and related services.",
    "keywords": "Yuvasakthi Academy terms and conditions, terms and conditions, Yuvasakthi Academy terms, online learning terms, training platform terms, course terms and conditions, Yuvasakthi Academy policies",
    "ogTitle": "Terms and Conditions | Yuvasakthi Academy",
    "ogDescription": "Read the Yuvasakthi Academy terms and conditions for using our website, online learning services, courses, accounts, and related services.",
    "ogUrl": "https://yslearn.in/terms-and-conditions",
    "ogSiteName": "Yuvasakthi Academy",
    "ogLocale": "en_IN",
    "ogImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "ogImageWidth": "1200",
    "ogImageHeight": "630",
    "ogImageAlt": "Yuvasakthi Academy Terms and Conditions",
    "ogType": "website",
    "twitterTitle": "Terms and Conditions | Yuvasakthi Academy",
    "twitterDescription": "Read the Yuvasakthi Academy terms and conditions for using our website, online learning services, courses, accounts, and related services.",
    "twitterCard": "summary_large_image",
    "twitterCreator": "@yslearn",
    "twitterImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "twitterImageWidth": "1200",
    "twitterImageHeight": "630",
    "twitterImageAlt": "Yuvasakthi Academy Terms and Conditions",
    "twitterSite": "@yslearn",
    "twitterUrl": "https://yslearn.in/terms-and-conditions",
    "searchTitle": "Yuvasakthi Academy Terms and Conditions",
    "focusArea": "Terms and Conditions, Website Usage, Online Learning Services and Course Policies",
    "primaryTaxonomy": "Legal > Terms and Conditions > Online Learning Services",
    "primaryTopic": "Yuvasakthi Academy Terms and Conditions",
    "pageType": "WebPage"
  },
  "/privacy": {
    "page": "Privacy Policy",
    "title": "Privacy Policy | Yuvasakthi Academy",
    "description": "Read the Yuvasakthi Academy privacy policy to understand how personal information is collected, used, protected, and managed when using our website and services.",
    "keywords": "Yuvasakthi Academy privacy policy, privacy policy, Yuvasakthi Academy privacy, data privacy, personal information protection, online learning privacy, user data protection, Yuvasakthi Academy",
    "ogTitle": "Privacy Policy | Yuvasakthi Academy",
    "ogDescription": "Learn how Yuvasakthi Academy handles personal information, data privacy, and user information when you use our website and services.",
    "ogUrl": "https://yslearn.in/privacy",
    "ogSiteName": "Yuvasakthi Academy",
    "ogLocale": "en_IN",
    "ogImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "ogImageWidth": "1200",
    "ogImageHeight": "630",
    "ogImageAlt": "Yuvasakthi Academy Privacy Policy",
    "ogType": "website",
    "twitterTitle": "Privacy Policy | Yuvasakthi Academy",
    "twitterDescription": "Learn how Yuvasakthi Academy handles personal information, data privacy, and user information when you use our website and services.",
    "twitterCard": "summary_large_image",
    "twitterCreator": "@yslearn",
    "twitterImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "twitterImageWidth": "1200",
    "twitterImageHeight": "630",
    "twitterImageAlt": "Yuvasakthi Academy Privacy Policy",
    "twitterSite": "@yslearn",
    "twitterUrl": "https://yslearn.in/privacy",
    "searchTitle": "Yuvasakthi Academy Privacy Policy",
    "focusArea": "Privacy, Personal Data Protection, User Information and Website Services",
    "primaryTaxonomy": "Legal > Privacy > Data Protection",
    "primaryTopic": "Yuvasakthi Academy Privacy Policy",
    "pageType": "WebPage"
  },
  "/refund-policy": {
    "page": "Refund Policy",
    "title": "Refund Policy | Yuvasakthi Academy",
    "description": "Read the Yuvasakthi Academy refund policy to understand the terms and conditions related to course purchases, refunds, cancellations, and payments.",
    "keywords": "Yuvasakthi Academy refund policy, refund policy, Yuvasakthi Academy refunds, course refund policy, online course refunds, course cancellation policy, training refund policy, Yuvasakthi Academy",
    "ogTitle": "Refund Policy | Yuvasakthi Academy",
    "ogDescription": "Learn about Yuvasakthi Academy's refund policy and the terms related to course purchases, refunds, cancellations, and payments.",
    "ogUrl": "https://yslearn.in/refund-policy",
    "ogSiteName": "Yuvasakthi Academy",
    "ogLocale": "en_IN",
    "ogImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "ogImageWidth": "1200",
    "ogImageHeight": "630",
    "ogImageAlt": "Yuvasakthi Academy Refund Policy",
    "ogType": "website",
    "twitterTitle": "Refund Policy | Yuvasakthi Academy",
    "twitterDescription": "Learn about Yuvasakthi Academy's refund policy and the terms related to course purchases, refunds, cancellations, and payments.",
    "twitterCard": "summary_large_image",
    "twitterCreator": "@yslearn",
    "twitterImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "twitterImageWidth": "1200",
    "twitterImageHeight": "630",
    "twitterImageAlt": "Yuvasakthi Academy Refund Policy",
    "twitterSite": "@yslearn",
    "twitterUrl": "https://yslearn.in/refund-policy",
    "searchTitle": "Yuvasakthi Academy Refund Policy",
    "focusArea": "Refunds, Course Purchases, Cancellations and Payment Policies",
    "primaryTaxonomy": "Legal > Refunds > Course Purchase Policies",
    "primaryTopic": "Yuvasakthi Academy Refund Policy",
    "pageType": "WebPage"
  },
  "/courses": {
    "page": "Courses",
    "title": "Online Courses & Professional Training Programs | Yuvasakthi Academy",
    "description": "Explore Yuvasakthi Academy online courses and professional training programs in technology, programming, AI, data science, cloud, DevOps, cybersecurity, and business skills.",
    "keywords": "Yuvasakthi Academy courses, online courses, professional training courses, online training programs, technology courses, programming courses, AI and machine learning courses, data science courses, cloud computing courses, DevOps courses, cybersecurity courses, career development courses",
    "ogTitle": "Online Courses & Professional Training Programs | Yuvasakthi Academy",
    "ogDescription": "Explore Yuvasakthi Academy courses and professional training programs covering technology, programming, AI, data science, cloud, DevOps, cybersecurity, and business skills.",
    "ogUrl": "https://yslearn.in/courses",
    "ogSiteName": "Yuvasakthi Academy",
    "ogLocale": "en_IN",
    "ogImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "ogImageWidth": "1200",
    "ogImageHeight": "630",
    "ogImageAlt": "Yuvasakthi Academy Online Courses and Professional Training Programs",
    "ogType": "website",
    "twitterTitle": "Online Courses & Professional Training Programs | Yuvasakthi Academy",
    "twitterDescription": "Explore Yuvasakthi Academy courses and professional training programs covering technology, programming, AI, data science, cloud, DevOps, cybersecurity, and business skills.",
    "twitterCard": "summary_large_image",
    "twitterCreator": "@yslearn",
    "twitterImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "twitterImageWidth": "1200",
    "twitterImageHeight": "630",
    "twitterImageAlt": "Yuvasakthi Academy Online Courses and Professional Training Programs",
    "twitterSite": "@yslearn",
    "twitterUrl": "https://yslearn.in/courses",
    "searchTitle": "Yuvasakthi Academy Courses - Online & Professional Training Programs",
    "focusArea": "Online Courses, Technology Training, Professional Skills and Career Development",
    "primaryTaxonomy": "Education > Online Learning > Professional Training",
    "primaryTopic": "Yuvasakthi Academy Online Courses and Training Programs",
    "pageType": "CollectionPage"
  },
  "/jobs": {
    "page": "Jobs",
    "title": "Jobs & Career Opportunities | Yuvasakthi Academy",
    "description": "Explore job opportunities and career openings at Yuvasakthi Academy. Find roles in training, technology, education, business, and other professional areas.",
    "keywords": "Yuvasakthi Academy jobs, Yuvasakthi Academy careers, Yuvasakthi Academy job openings, career opportunities, jobs in Yuvasakthi Academy, training jobs, education jobs, technology jobs, professional careers, job vacancies",
    "ogTitle": "Jobs & Career Opportunities | Yuvasakthi Academy",
    "ogDescription": "Explore career opportunities and job openings at Yuvasakthi Academy across training, technology, education, business, and professional roles.",
    "ogUrl": "https://yslearn.in/jobs",
    "ogSiteName": "Yuvasakthi Academy",
    "ogLocale": "en_IN",
    "ogImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "ogImageWidth": "1200",
    "ogImageHeight": "630",
    "ogImageAlt": "Yuvasakthi Academy Jobs and Career Opportunities",
    "ogType": "website",
    "twitterTitle": "Jobs & Career Opportunities | Yuvasakthi Academy",
    "twitterDescription": "Explore career opportunities and job openings at Yuvasakthi Academy across training, technology, education, business, and professional roles.",
    "twitterCard": "summary_large_image",
    "twitterCreator": "@yslearn",
    "twitterImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "twitterImageWidth": "1200",
    "twitterImageHeight": "630",
    "twitterImageAlt": "Yuvasakthi Academy Jobs and Career Opportunities",
    "twitterSite": "@yslearn",
    "twitterUrl": "https://yslearn.in/jobs",
    "searchTitle": "Yuvasakthi Academy Jobs - Career Opportunities & Job Openings",
    "focusArea": "Jobs, Career Opportunities, Employment and Professional Roles",
    "primaryTaxonomy": "Careers > Jobs > Employment Opportunities",
    "primaryTopic": "Yuvasakthi Academy Jobs and Career Opportunities",
    "pageType": "WebPage"
  },
  "/categories": {
    "page": "Course Categories",
    "title": "Course Categories | Online Learning & Training | Yuvasakthi Academy",
    "description": "Explore Yuvasakthi Academy course categories and discover online training programs across technology, professional skills, career development, and digital learning.",
    "keywords": "Yuvasakthi Academy categories, course categories, online course categories, training categories, online learning programs, professional training, technology training, career development courses, digital skills training, Yuvasakthi Academy courses",
    "ogTitle": "Course Categories | Online Learning & Training | Yuvasakthi Academy",
    "ogDescription": "Explore Yuvasakthi Academy course categories and discover online training programs for technology, professional skills, career development, and digital learning.",
    "ogUrl": "https://yslearn.in/categories",
    "ogSiteName": "Yuvasakthi Academy",
    "ogLocale": "en_IN",
    "ogImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "ogImageWidth": "1200",
    "ogImageHeight": "630",
    "ogImageAlt": "Yuvasakthi Academy Course Categories and Online Training Programs",
    "ogType": "website",
    "twitterTitle": "Course Categories | Online Learning & Training | Yuvasakthi Academy",
    "twitterDescription": "Explore Yuvasakthi Academy course categories and discover online training programs for technology, professional skills, career development, and digital learning.",
    "twitterCard": "summary_large_image",
    "twitterCreator": "@yslearn",
    "twitterImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "twitterImageWidth": "1200",
    "twitterImageHeight": "630",
    "twitterImageAlt": "Yuvasakthi Academy Course Categories and Online Training Programs",
    "twitterSite": "@yslearn",
    "twitterUrl": "https://yslearn.in/categories",
    "searchTitle": "Yuvasakthi Academy Course Categories - Online Training Programs",
    "focusArea": "Course Categories, Online Learning, Professional Training and Digital Skills",
    "primaryTaxonomy": "Education > Online Learning > Course Categories",
    "primaryTopic": "Yuvasakthi Academy Course Categories",
    "pageType": "CollectionPage"
  },
  "/search-new": {
    "page": "Search",
    "title": "Search Courses & Learning Programs | Yuvasakthi Academy",
    "description": "Search Yuvasakthi Academy for online courses, professional training programs, technology skills, and career-focused learning opportunities.",
    "keywords": "Yuvasakthi Academy search, search courses, online course search, find training courses, online learning programs, professional training, technology courses, career training, Yuvasakthi Academy courses",
    "ogTitle": "Search Courses & Learning Programs | Yuvasakthi Academy",
    "ogDescription": "Search Yuvasakthi Academy to find online courses, professional training programs, technology skills, and career-focused learning opportunities.",
    "ogUrl": "https://yslearn.in/search-new",
    "ogSiteName": "Yuvasakthi Academy",
    "ogLocale": "en_IN",
    "ogImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "ogImageWidth": "1200",
    "ogImageHeight": "630",
    "ogImageAlt": "Yuvasakthi Academy Search Courses and Learning Programs",
    "ogType": "website",
    "twitterTitle": "Search Courses & Learning Programs | Yuvasakthi Academy",
    "twitterDescription": "Search Yuvasakthi Academy to find online courses, professional training programs, technology skills, and career-focused learning opportunities.",
    "twitterCard": "summary_large_image",
    "twitterCreator": "@yslearn",
    "twitterImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "twitterImageWidth": "1200",
    "twitterImageHeight": "630",
    "twitterImageAlt": "Yuvasakthi Academy Search Courses and Learning Programs",
    "twitterSite": "@yslearn",
    "twitterUrl": "https://yslearn.in/search-new",
    "searchTitle": "Yuvasakthi Academy Search - Courses & Learning Programs",
    "focusArea": "Course Search, Online Learning, Professional Training and Career Development",
    "primaryTaxonomy": "Education > Online Learning > Course Search",
    "primaryTopic": "Yuvasakthi Academy Course Search",
    "pageType": "WebPage"
  },
  "/cart": {
    "page": "Course Cart",
    "title": "Course Cart | Yuvasakthi Academy",
    "description": "Review your selected Yuvasakthi Academy courses and prepare for enrollment through the online course cart.",
    "keywords": "Yuvasakthi Academy cart, course cart, online course cart, selected courses, course enrollment, online course enrollment, Yuvasakthi Academy courses",
    "ogTitle": "Course Cart | Yuvasakthi Academy",
    "ogDescription": "Review your selected Yuvasakthi Academy courses and prepare for online course enrollment.",
    "ogUrl": "https://yslearn.in/cart",
    "ogSiteName": "Yuvasakthi Academy",
    "ogLocale": "en_IN",
    "ogImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "ogImageWidth": "1200",
    "ogImageHeight": "630",
    "ogImageAlt": "Yuvasakthi Academy Course Cart",
    "ogType": "website",
    "twitterTitle": "Course Cart | Yuvasakthi Academy",
    "twitterDescription": "Review your selected Yuvasakthi Academy courses and prepare for online course enrollment.",
    "twitterCard": "summary_large_image",
    "twitterCreator": "@yslearn",
    "twitterImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "twitterImageWidth": "1200",
    "twitterImageHeight": "630",
    "twitterImageAlt": "Yuvasakthi Academy Course Cart",
    "twitterSite": "@yslearn",
    "twitterUrl": "https://yslearn.in/cart",
    "searchTitle": "Yuvasakthi Academy Course Cart - Review Selected Courses",
    "focusArea": "Course Cart, Course Enrollment and Online Learning",
    "primaryTaxonomy": "Education > Online Learning > Course Enrollment",
    "primaryTopic": "Yuvasakthi Academy Course Cart",
    "pageType": "WebPage"
  },
  "/special-offers": {
    "page": "Special Offers",
    "title": "Special Offers on Online Courses | Yuvasakthi Academy",
    "description": "Explore special offers from Yuvasakthi Academy on online courses and professional training programs designed to support digital skills and career development.",
    "keywords": "Yuvasakthi Academy special offers, online course offers, training course offers, course promotions, online learning offers, professional training offers, course discounts, Yuvasakthi Academy courses",
    "ogTitle": "Special Offers on Online Courses | Yuvasakthi Academy",
    "ogDescription": "Explore Yuvasakthi Academy special offers on online courses and professional training programs for digital skills and career development.",
    "ogUrl": "https://yslearn.in/special-offers",
    "ogSiteName": "Yuvasakthi Academy",
    "ogLocale": "en_IN",
    "ogImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "ogImageWidth": "1200",
    "ogImageHeight": "630",
    "ogImageAlt": "Yuvasakthi Academy Special Offers on Online Courses",
    "ogType": "website",
    "twitterTitle": "Special Offers on Online Courses | Yuvasakthi Academy",
    "twitterDescription": "Explore Yuvasakthi Academy special offers on online courses and professional training programs for digital skills and career development.",
    "twitterCard": "summary_large_image",
    "twitterCreator": "@yslearn",
    "twitterImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "twitterImageWidth": "1200",
    "twitterImageHeight": "630",
    "twitterImageAlt": "Yuvasakthi Academy Special Offers on Online Courses",
    "twitterSite": "@yslearn",
    "twitterUrl": "https://yslearn.in/special-offers",
    "searchTitle": "Yuvasakthi Academy Special Offers - Online Course & Training Offers",
    "focusArea": "Special Offers, Online Courses, Training Promotions and Career Development",
    "primaryTaxonomy": "Education > Online Learning > Course Offers",
    "primaryTopic": "Yuvasakthi Academy Special Offers",
    "pageType": "CollectionPage"
  },
  "/business": {
    "page": "Business",
    "title": "Business Training & Corporate Learning Solutions | Yuvasakthi Academy",
    "description": "Explore Yuvasakthi Academy business training and corporate learning solutions designed to help organizations build digital skills, upskill teams, and support professional development.",
    "keywords": "Yuvasakthi Academy business, business training, corporate training, corporate learning solutions, employee upskilling, digital skills training, business skills training, corporate learning programs, professional development, Yuvasakthi Academy corporate training",
    "ogTitle": "Business Training & Corporate Learning Solutions | Yuvasakthi Academy",
    "ogDescription": "Discover Yuvasakthi Academy business and corporate learning solutions for digital skills training, employee upskilling, and professional development.",
    "ogUrl": "https://yslearn.in/business",
    "ogSiteName": "Yuvasakthi Academy",
    "ogLocale": "en_IN",
    "ogImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "ogImageWidth": "1200",
    "ogImageHeight": "630",
    "ogImageAlt": "Yuvasakthi Academy Business and Corporate Training Solutions",
    "ogType": "website",
    "twitterTitle": "Business Training & Corporate Learning Solutions | Yuvasakthi Academy",
    "twitterDescription": "Discover Yuvasakthi Academy business and corporate learning solutions for digital skills training, employee upskilling, and professional development.",
    "twitterCard": "summary_large_image",
    "twitterCreator": "@yslearn",
    "twitterImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "twitterImageWidth": "1200",
    "twitterImageHeight": "630",
    "twitterImageAlt": "Yuvasakthi Academy Business and Corporate Training Solutions",
    "twitterSite": "@yslearn",
    "twitterUrl": "https://yslearn.in/business",
    "searchTitle": "Yuvasakthi Academy Business - Corporate Training & Learning Solutions",
    "focusArea": "Corporate Training, Business Learning, Employee Upskilling and Digital Skills",
    "primaryTaxonomy": "Business > Corporate Training > Professional Development",
    "primaryTopic": "Yuvasakthi Academy Business and Corporate Training Solutions",
    "pageType": "WebPage"
  },
  "/pricing": {
    "page": "Pricing",
    "title": "Course Pricing & Training Plans | Yuvasakthi Academy",
    "description": "Explore Yuvasakthi Academy course pricing and training plans for online learning, professional skills, technology courses, and career-focused training programs.",
    "keywords": "Yuvasakthi Academy pricing, course pricing, online course pricing, training course fees, course fees, online training plans, professional training pricing, technology course fees, Yuvasakthi Academy courses",
    "ogTitle": "Course Pricing & Training Plans | Yuvasakthi Academy",
    "ogDescription": "Explore Yuvasakthi Academy course pricing and training plans for online learning, professional skills, technology courses, and career-focused training.",
    "ogUrl": "https://yslearn.in/pricing",
    "ogSiteName": "Yuvasakthi Academy",
    "ogLocale": "en_IN",
    "ogImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "ogImageWidth": "1200",
    "ogImageHeight": "630",
    "ogImageAlt": "Yuvasakthi Academy Course Pricing and Training Plans",
    "ogType": "website",
    "twitterTitle": "Course Pricing & Training Plans | Yuvasakthi Academy",
    "twitterDescription": "Explore Yuvasakthi Academy course pricing and training plans for online learning, professional skills, technology courses, and career-focused training.",
    "twitterCard": "summary_large_image",
    "twitterCreator": "@yslearn",
    "twitterImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "twitterImageWidth": "1200",
    "twitterImageHeight": "630",
    "twitterImageAlt": "Yuvasakthi Academy Course Pricing and Training Plans",
    "twitterSite": "@yslearn",
    "twitterUrl": "https://yslearn.in/pricing",
    "searchTitle": "Yuvasakthi Academy Pricing - Course Fees & Training Plans",
    "focusArea": "Course Pricing, Training Fees, Online Learning and Professional Training",
    "primaryTaxonomy": "Education > Online Learning > Course Pricing",
    "primaryTopic": "Yuvasakthi Academy Course Pricing and Training Plans",
    "pageType": "WebPage"
  },
  "/features": {
    "page": "Features",
    "title": "Features | Online Learning & Training Platform | Yuvasakthi Academy",
    "description": "Discover Yuvasakthi Academy features including interactive learning, practical training, live projects, personalized mentorship, flexible access, expert webinars, and career assistance.",
    "keywords": "Yuvasakthi Academy features, online learning platform features, interactive learning, practical training, live projects, personalized mentorship, flexible learning, expert webinars, career assistance, digital skills training",
    "ogTitle": "Features | Online Learning & Training Platform | Yuvasakthi Academy",
    "ogDescription": "Discover Yuvasakthi Academy learning features including interactive training, live projects, personalized mentorship, flexible access, expert webinars, and career assistance.",
    "ogUrl": "https://yslearn.in/features",
    "ogSiteName": "Yuvasakthi Academy",
    "ogLocale": "en_IN",
    "ogImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "ogImageWidth": "1200",
    "ogImageHeight": "630",
    "ogImageAlt": "Yuvasakthi Academy Online Learning Platform Features",
    "ogType": "website",
    "twitterTitle": "Features | Online Learning & Training Platform | Yuvasakthi Academy",
    "twitterDescription": "Discover Yuvasakthi Academy learning features including interactive training, live projects, personalized mentorship, flexible access, expert webinars, and career assistance.",
    "twitterCard": "summary_large_image",
    "twitterCreator": "@yslearn",
    "twitterImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "twitterImageWidth": "1200",
    "twitterImageHeight": "630",
    "twitterImageAlt": "Yuvasakthi Academy Online Learning Platform Features",
    "twitterSite": "@yslearn",
    "twitterUrl": "https://yslearn.in/features",
    "searchTitle": "Yuvasakthi Academy Features - Online Learning & Training Platform",
    "focusArea": "Interactive Learning, Practical Training, Live Projects, Mentorship and Career Assistance",
    "primaryTaxonomy": "Education > Online Learning > Learning Platform Features",
    "primaryTopic": "Yuvasakthi Academy Learning Platform Features",
    "pageType": "WebPage"
  },
  "/events": {
    "page": "Events",
    "title": "Events, Webinars & Workshops | Yuvasakthi Academy",
    "description": "Explore Yuvasakthi Academy events, webinars, workshops, seminars, and learning activities designed to support professional skills, technology knowledge, and career development.",
    "keywords": "Yuvasakthi Academy events, Yuvasakthi Academy webinars, Yuvasakthi Academy workshops, online learning events, technology webinars, training workshops, professional development events, online seminars, career development events, Yuvasakthi Academy",
    "ogTitle": "Events, Webinars & Workshops | Yuvasakthi Academy",
    "ogDescription": "Explore Yuvasakthi Academy events, webinars, workshops, and learning activities focused on professional skills, technology knowledge, and career development.",
    "ogUrl": "https://yslearn.in/events",
    "ogSiteName": "Yuvasakthi Academy",
    "ogLocale": "en_IN",
    "ogImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "ogImageWidth": "1200",
    "ogImageHeight": "630",
    "ogImageAlt": "Yuvasakthi Academy Events, Webinars and Workshops",
    "ogType": "website",
    "twitterTitle": "Events, Webinars & Workshops | Yuvasakthi Academy",
    "twitterDescription": "Explore Yuvasakthi Academy events, webinars, workshops, and learning activities focused on professional skills, technology knowledge, and career development.",
    "twitterCard": "summary_large_image",
    "twitterCreator": "@yslearn",
    "twitterImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "twitterImageWidth": "1200",
    "twitterImageHeight": "630",
    "twitterImageAlt": "Yuvasakthi Academy Events, Webinars and Workshops",
    "twitterSite": "@yslearn",
    "twitterUrl": "https://yslearn.in/events",
    "searchTitle": "Yuvasakthi Academy Events - Webinars, Workshops & Learning Activities",
    "focusArea": "Events, Webinars, Workshops, Technology Learning and Professional Development",
    "primaryTaxonomy": "Education > Events > Webinars and Workshops",
    "primaryTopic": "Yuvasakthi Academy Events and Learning Activities",
    "pageType": "CollectionPage"
  },
  "/faq": {
    "page": "FAQ",
    "title": "Frequently Asked Questions (FAQ) | Yuvasakthi Academy",
    "description": "Find answers to frequently asked questions about Yuvasakthi Academy courses, online training, enrollment, learning programs, and professional skills development.",
    "keywords": "Yuvasakthi Academy FAQ, Yuvasakthi Academy frequently asked questions, online course FAQ, training FAQ, course enrollment questions, online learning questions, Yuvasakthi Academy courses, professional training FAQ",
    "ogTitle": "Frequently Asked Questions (FAQ) | Yuvasakthi Academy",
    "ogDescription": "Find answers to common questions about Yuvasakthi Academy courses, online training, enrollment, learning programs, and professional skills development.",
    "ogUrl": "https://yslearn.in/faq",
    "ogSiteName": "Yuvasakthi Academy",
    "ogLocale": "en_IN",
    "ogImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "ogImageWidth": "1200",
    "ogImageHeight": "630",
    "ogImageAlt": "Yuvasakthi Academy Frequently Asked Questions",
    "ogType": "website",
    "twitterTitle": "Frequently Asked Questions (FAQ) | Yuvasakthi Academy",
    "twitterDescription": "Find answers to common questions about Yuvasakthi Academy courses, online training, enrollment, learning programs, and professional skills development.",
    "twitterCard": "summary_large_image",
    "twitterCreator": "@yslearn",
    "twitterImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "twitterImageWidth": "1200",
    "twitterImageHeight": "630",
    "twitterImageAlt": "Yuvasakthi Academy Frequently Asked Questions",
    "twitterSite": "@yslearn",
    "twitterUrl": "https://yslearn.in/faq",
    "searchTitle": "Yuvasakthi Academy FAQ - Frequently Asked Questions About Courses & Training",
    "focusArea": "Frequently Asked Questions, Courses, Online Training, Enrollment and Learning Programs",
    "primaryTaxonomy": "Education > Online Learning > Frequently Asked Questions",
    "primaryTopic": "Yuvasakthi Academy Frequently Asked Questions",
    "pageType": "FAQPage"
  },
  "/teachers": {
    "page": "Teachers",
    "title": "Expert Trainers & Instructors | Yuvasakthi Academy",
    "description": "Meet Yuvasakthi Academy's expert trainers and instructors who provide practical, industry-focused training, mentorship, and guidance across technology and professional skills.",
    "keywords": "Yuvasakthi Academy teachers, Yuvasakthi Academy trainers, Yuvasakthi Academy instructors, expert trainers, online course instructors, industry expert trainers, professional training instructors, technology trainers, career mentorship, Yuvasakthi Academy",
    "ogTitle": "Expert Trainers & Instructors | Yuvasakthi Academy",
    "ogDescription": "Meet Yuvasakthi Academy's expert trainers and instructors providing practical, industry-focused training, mentorship, and professional learning guidance.",
    "ogUrl": "https://yslearn.in/teachers",
    "ogSiteName": "Yuvasakthi Academy",
    "ogLocale": "en_IN",
    "ogImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "ogImageWidth": "1200",
    "ogImageHeight": "630",
    "ogImageAlt": "Yuvasakthi Academy Expert Trainers and Instructors",
    "ogType": "website",
    "twitterTitle": "Expert Trainers & Instructors | Yuvasakthi Academy",
    "twitterDescription": "Meet Yuvasakthi Academy's expert trainers and instructors providing practical, industry-focused training, mentorship, and professional learning guidance.",
    "twitterCard": "summary_large_image",
    "twitterCreator": "@yslearn",
    "twitterImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "twitterImageWidth": "1200",
    "twitterImageHeight": "630",
    "twitterImageAlt": "Yuvasakthi Academy Expert Trainers and Instructors",
    "twitterSite": "@yslearn",
    "twitterUrl": "https://yslearn.in/teachers",
    "searchTitle": "Yuvasakthi Academy Teachers - Expert Trainers & Instructors",
    "focusArea": "Expert Trainers, Industry Instructors, Practical Training and Mentorship",
    "primaryTaxonomy": "Education > Online Learning > Trainers and Instructors",
    "primaryTopic": "Yuvasakthi Academy Expert Trainers and Instructors",
    "pageType": "CollectionPage"
  },
  "/cookies": {
    "page": "Cookies",
    "title": "Cookie Policy | Yuvasakthi Academy",
    "description": "Read the Yuvasakthi Academy Cookie Policy to understand how cookies and similar technologies are used to support website functionality, improve user experience, analyze website usage, and provide relevant services.",
    "keywords": "Yuvasakthi Academy Cookie Policy, Cookie Policy, Yuvasakthi Academy Cookies, Website Cookies, Cookie Usage, Online Learning Cookies, Website Tracking Technologies, Yuvasakthi Academy Privacy",
    "ogTitle": "Cookie Policy | Yuvasakthi Academy",
    "ogDescription": "Learn how cookies and similar technologies are used on the Yuvasakthi Academy website and how they support website functionality, user experience, and usage analysis.",
    "ogUrl": "https://yslearn.in/cookies",
    "ogSiteName": "Yuvasakthi Academy",
    "ogLocale": "en_IN",
    "ogImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "ogImageWidth": "1200",
    "ogImageHeight": "630",
    "ogImageAlt": "Yuvasakthi Academy Cookie Policy",
    "ogType": "website",
    "twitterTitle": "Cookie Policy | Yuvasakthi Academy",
    "twitterDescription": "Learn how cookies and similar technologies may be used on the Yuvasakthi Academy website and understand their role in website functionality and usage.",
    "twitterCard": "summary_large_image",
    "twitterCreator": "@yslearn",
    "twitterImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "twitterImageWidth": "1200",
    "twitterImageHeight": "630",
    "twitterImageAlt": "Yuvasakthi Academy Cookie Policy",
    "twitterSite": "@yslearn",
    "twitterUrl": "https://yslearn.in/cookies",
    "searchTitle": "Yuvasakthi Academy Cookie Policy",
    "focusArea": "Cookies, Website Usage, Privacy and Tracking Technologies",
    "primaryTaxonomy": "Legal > Privacy > Cookie Policy",
    "primaryTopic": "Yuvasakthi Academy Cookie Policy",
    "pageType": "WebPage"
  },
  "/trademarkpolicy": {
    "page": "Trade Mark Policy",
    "title": "Trademark Policy | Yuvasakthi Academy",
    "description": "Read the Yuvasakthi Academy trademark policy to understand the use and protection of Yuvasakthi Academy names, logos, trademarks, and related brand assets.",
    "keywords": "Yuvasakthi Academy trademark policy, trademark policy, Yuvasakthi Academy trademarks, Yuvasakthi Academy brand policy, trademark usage, brand usage policy,",
    "ogTitle": "Trademark Policy | Yuvasakthi Academy",
    "ogDescription": "Learn about the use and protection of Yuvasakthi Academy names, logos, trademarks, and related brand assets.",
    "ogUrl": "https://yslearn.in/trademarkpolicy",
    "ogSiteName": "Yuvasakthi Academy",
    "ogLocale": "en_IN",
    "ogImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "ogImageWidth": "1200",
    "ogImageHeight": "630",
    "ogImageAlt": "Yuvasakthi Academy Trademark Policy",
    "ogType": "website",
    "twitterTitle": "Trademark Policy | Yuvasakthi Academy",
    "twitterDescription": "Learn about the use and protection of Yuvasakthi Academy names, logos, trademarks, and related brand assets.",
    "twitterCard": "summary_large_image",
    "twitterCreator": "@yslearn",
    "twitterImage": "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/logo.5aa40f66256266e8c528.png",
    "twitterImageWidth": "1200",
    "twitterImageHeight": "630",
    "twitterImageAlt": "Yuvasakthi Academy Trademark Policy",
    "twitterSite": "@yslearn",
    "twitterUrl": "https://yslearn.in/trademarkpolicy",
    "searchTitle": "Yuvasakthi Academy Trademark Policy",
    "focusArea": "Trademarks, Brand Usage, Intellectual Property and Brand Protection",
    "primaryTaxonomy": "Legal > Intellectual Property > Trademark Policy",
    "primaryTopic": "Yuvasakthi Academy Trademark Policy",
    "pageType": "WebPage"
  }
};

export default seoMetadata;
